<template>
  <div class="nav2Box z1200">
    <div v-show="!ispayShow" class="top_set">
      <a href="user?index=0">通行证首页</a>
      <span> >我的钱包</span>
    </div>
    <div v-show="!ispayShow" class="topmsg">
      <div class="list1">
        <div class="list_left">
          <svg-icon icon-class="qiandai" />
        </div>
        <p class="list_right">
          <span class="span1">账户余额</span>
          <span class="span2">{{ userData1.incomeBalance }}</span>
        </p>
      </div>
      <div class="list1">
        <div class="list_left" style="background-color: #68CA77;">
          <svg-icon icon-class="shouru" />
        </div>
        <p class="list_right">
          <span class="span1">今日收入</span>
          <span class="span2" style="color: #68CA77">{{ userData1.incomeToday }}</span>
        </p>
      </div>
      <div class="list1">
        <div class="list_left" style="background-color: #F9C071;">
          <svg-icon icon-class="zhichu" />
        </div>
        <p class="list_right">
          <span class="span1">今日支出</span>
          <span class="span2" style="color: #F9C071">{{ userData1.incomeTodayExpend }}</span>
        </p>
      </div>
      <div class="list_last">
        <span style="margin-left: 65px;" @click="isPay">充值</span>
        <span style="margin-left: 35px;" @click="tixian">提现</span>
      </div>
    </div>
    <div v-show="!ispayShow" class="box_content">
      <div class="tips">
        收支明细
      </div>
      <div class="controlBox">
        <div class="controlBox_div1">
          <span class="tipsname">交易时间：</span>
          <div class="select1">
            <el-date-picker
              v-model="NowData1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="changeTime1"
            />
          </div>
          <span class="tipsname">最近</span>
          <span :class="timetypeindex==1?'btn_type1_avtive':'btn_type1'" @click="timeBtn1(1)">一周</span>
          <span :class="timetypeindex==2?'btn_type1_avtive':'btn_type1'" @click="timeBtn1(2)">一月</span>
          <span :class="timetypeindex==3?'btn_type1_avtive':'btn_type1'" @click="timeBtn1(3)">一年</span>
          <div class="select2">
            <span>按月选择 <svg-icon icon-class="sanjiaoxia" /></span>
            <div class="selectInput">
              <el-date-picker
                v-model="NowData2"
                type="month"
                placeholder="按月选择"
                @change="changeTime2"
              />
            </div>
          </div>
          <div class="btn_type2">
            <span v-if="thistype" @click="thistype=false">高级筛选 <svg-icon icon-class="sanjiaoxia" /></span>
            <span v-if="!thistype" @click="thistype=true">基本筛选 <svg-icon icon-class="sanjiaoshang" /></span>
          </div>
        </div>
        <div v-show="!thistype" class="controlMore">
          <div class="controlMore_lis">
            <span class="tipsname">收支类型：</span>
            <span :class="shouzhitypeindex==-1?'btn_type1_avtive':'btn_type1'" @click="changewalletType(-1)">全部</span>
            <span :class="shouzhitypeindex==1?'btn_type1_avtive':'btn_type1'" @click="changewalletType(1)">收入</span>
            <span :class="shouzhitypeindex==2?'btn_type1_avtive':'btn_type1'" @click="changewalletType(2)">支出</span>
          </div>
          <div class="controlMore_lis controlMore_lis2">
            <span class="tipsname">交易类型：</span>
            <span v-for="(item,index) in jiaoyiType" :key="index" @click="changetradeType(item,index)">
              <span v-show="item.type==-1||item.type==shouzhitypeindex||shouzhitypeindex==-1" :class="tradeTypeindex==index?'btn_type1_avtive':'btn_type1'">{{ item.name }}</span>
            </span>
          </div>
          <div class="controlMore_lis controlMore_lis2" style="height: 40px;">
            <span class="tipsname">关键字：</span>
            <div class="inputSearch">
              <el-input v-model="searchKey" placeholder="请输入交易编号，交易描述关键字" />
              <span class="iconsearch" @click="changeData">
                <svg-icon icon-class="sousuo" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!ispayShow" class="box_list">
      <TableTemolate :option="option" :columns="columns" :selection="false" data-type="wallerDetails" />
    </div>
    <div v-show="ispayShow">
      <payCenter2 />
    </div>
  </div>
</template>

<script>
import { loadWallet, loadIndex, findWallerDetails } from '@/api/api.js'
import TableTemolate from '@/components/passcardNav/tableTemolate.vue'
import payCenter2 from '@/components/passcardNav/payCenter2.vue'
export default {
  components: {
    TableTemolate, payCenter2
  },
  inject: ['reload'],
  data() {
    return {
      ispayShow: false,
      searchKey: '',
      timetypeindex: 1,
      shouzhitypeindex: -1,
      tradeTypeindex: 0,
      thistype: true,
      userData1: {},
      listData: [],
      NowData1: '',
      NowData2: '',
      option: {
        pageSize: 10,
        ajax: {
          url: '/passportWallet/findWallerDetails', // /获取列表数据的地址
          type: 'post'
        },
        param: {
          passportid: '',
          index: 1,
          size: 10,
          startDate: '', // /始
          endDate: '', // 末
          walletType: '', // /收支类型
          tradeType: '', // 交易类型
          str: '', // 搜索关键字
          sortType: 2 // 时间排序
        }
      },
      columns: [
        { 'prop': 'TRADE_ID', label: '交易编号', width: '300px' },
        { 'prop': 'CREATE_DATE', label: '交易时间', width: '200px' },
        { 'prop': 'TRADE_TYPE', label: '交易类型', width: '80px' },
        { 'prop': 'TRADE_DESC_TITLE', label: '描述', width: '200px' },
        { 'prop': 'WALLET_TYPE', label: '收支类型' },
        { 'prop': 'WALLET_AMOUNT', label: '收支', width: '60px' },
        { 'prop': 'WALLET_BALANCE', label: '账户余额', width: '120px' },
        { 'prop': 'SYSTEM_NAME', label: '平台', width: '100px' }
      ],
      jiaoyiType: [
        { name: '全部', id: '', type: '-1' },
        { name: '充值', id: '2c9e80676d1e4dd7016d1f302bfc001d', type: '1' },
        { name: '打赏', id: '2c9e80676d1e4dd7016d1f324ab6001f', type: '-1' },
        { name: '消费', id: '2c9e80676d1e4dd7016d1f32f5bc0020', type: '2' },
        { name: '收益', id: '2c9e80676d1e4dd7016d1f31f718001e', type: '1' },
        { name: '提现', id: '2c9e80676d1e4dd7016d1f3c2d300021', type: '2' }
      ],
      jiaoyiType1: [
        { name: '充值', id: '2c9e80676d1e4dd7016d1f302bfc001d' },
        { name: '打赏', id: '2c9e80676d1e4dd7016d1f324ab6001f' },
        { name: '消费', id: '2c9e80676d1e4dd7016d1f32f5bc0020' }
      ],
      jiaoyiType2: [
        { name: '打赏', id: '2c9e80676d1e4dd7016d1f324ab6001f' },
        { name: '收益', id: '2c9e80676d1e4dd7016d1f31f718001e' },
        { name: '提现', id: '2c9e80676d1e4dd7016d1f3c2d300021' }
      ]
    }
    // /初始化数据
  },
  mounted() {
    this.fetchData()
    // this.imgCutUploadParams.param.userId = this.getLoca('userid')
    // console.log(dataJson)
    // this.countryData = dataJson.dataJson
  },
  methods: {
    fetchData() {
      if (this.getLoca('passportid')) {
        this.option.param.passportid = this.getLoca('passportid')
        loadWallet({ passportid: this.getLoca('passportid') }).then(res => {
          this.userData1 = res.data
          this.listData = res.data.wallerDetails.listMapData
        })
      } else {
        loadIndex().then(res => {
          this.option.param.passportid = res.data.passportUser.passportid
          this.setloca('passportid', res.data.passportUser.passportid, 7200)
          loadWallet({ passportid: this.option.param.passportid }).then(res => {
            this.userData1 = res.data
            this.listData = res.data.wallerDetails.listMapData
          })
        })
      }
    },
    changeData() {
      this.option.param.str = this.searchKey
    },
    changeTime1(data) {
      console.log(data)
      this.option.param.startDate = data[0]
      this.option.param.endDate = data[1]
    },
    changeTime2(data) {
      var year = data.getFullYear()
      var month = data.getMonth() + 1
      var d = new Date(year, month, 0)
      this.option.param.endDate = year + '-' + month + '-' + d.getDate()
      this.option.param.startDate = year + '-' + month + '-' + '01'
      this.NowData1 = []
      this.NowData1.push(this.option.param.startDate)
      this.NowData1.push(this.option.param.endDate)
    },
    timeBtn1(type) {
      this.timetypeindex = type
      var data = new Date()
      var year = data.getFullYear()
      var month = data.getMonth() + 1
      var day = data.getDate()
      this.option.param.endDate = year + '-' + month + '-' + day
      if (type == 1) {
        if (day >= 7) {
          this.option.param.startDate = year + '-' + month + '-' + (day - 6)
        } else {
          if (month > 1) {
            var d = new Date(year, month - 1, 0)
            this.option.param.startDate = year + '-' + (month - 1) + '-' + (d.getDate() - 6) + day
          } else {
            year--
            var d2 = new Date(year, 12, 0)
            this.option.param.startDate = year + '-' + '12' + '-' + (d2.getDate() - 6) + day
          }
        }
      }
      if (type == 2) {
        if (month > 1) {
          month--
        } else {
          year--
          month = 12
        }
        this.option.param.startDate = year + '-' + month + '-' + day
      }
      if (type == 3) {
        this.option.param.startDate = (year - 1) + '-' + month + '-' + day
      }
    },
    changewalletType(type) {
      this.shouzhitypeindex = type
      if (type != -1) {
        this.option.param.walletType = type
      } else {
        this.option.param.walletType = ''
      }
    },
    changetradeType(item, index) {
      this.tradeTypeindex = index
      if (item.id) {
        this.option.param.tradeType = item.id
      } else {
        this.option.param.tradeType = ''
      }
    },
    isPay() {
      this.ispayShow = true
    },
    tixian() {
      this.$message({
        type: 'warning',
        message: '该功能暂未开放，敬请期待'
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .z1200{
        width: 1200px;
        margin: 0 auto;
    }
    .nav2Box{
        overflow: hidden;
        min-height: 100vh;
        .top_set{
            height: 80px;
            line-height: 80px;
            text-align: left;
            font-size: 14px;
            a{
                color: #999999;
            }
            span{
                color: #666666;
            }
        }
        .topmsg{
            padding: 20px 0px;
            background-color: #fff;
            overflow: hidden;
            margin-bottom: 10px;
            .list1{
                display: inline-block;
                vertical-align: top;
                width: 300px;
                height: 50px;
                border-right: 1px solid #EEEEEE;
                .list_left{
                    display: inline-block;
                    width: 50px;
                    height: 50px;
                    background-color: #E0466E;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 50px;
                    margin-left: 70px;
                    vertical-align: top;
                    svg{
                        color: #ffffff;
                        font-size: 30px;
                        vertical-align: middle;
                    }
                }
                .list_right{
                    width: 160px;
                    height: 50px;
                    display: inline-block;
                    vertical-align: top;
                    margin-left: 10px;
                    .span1{
                        display: inline-block;
                        width: 160px;
                        height: 20px;
                        line-height: 20px;
                        font-size: 14px;
                        color: #999999;
                    }
                    .span2{
                        display: inline-block;
                        width: 160px;
                        height: 24px;
                        line-height: 24px;
                        font-size: 24px;
                        color: #E3003A;
                        margin-top: 6px;
                    }
                }
            }
            .list_last{
                display: inline-block;
                vertical-align: top;
                width: 296px;
                height: 50px;
                line-height: 50px;
                span{
                    background-color: #F3F8FF;
                    padding: 5px 15px;
                    border: 1px solid #BCD4F5;
                    color: #666666;
                    border-radius: 3px;
                    cursor: pointer;
                    font-size: 14px;
                }
            }
        }
        .box_content{
            background-color: #fff;
            padding: 20px 30px;
            overflow: hidden;
        }
        .tips{
            display: inline-block;
            padding-left: 7px;
            border-left: 3px solid #E0466E;
            height: 17px;
            line-height: 17px;
            margin-top: 30px;
            font-size: 18px;
        }
        .controlBox{
            background-color: #F1F7FF;
            padding: 20px 30px;
            margin-top: 25px;
            .tipsname{
                color: #999;
                font-size: 14px;
            }
            .controlBox_div1{
                height: 35px;
                line-height: 35px;
                .select1{
                    display: inline-block;
                    width: 350px;
                    vertical-align: top;
                    margin-left: 14px;
                    margin-right: 45px;
                    height: 35px;
                }
                .select2{
                    width: 80px;
                    position: relative;
                    display: inline-block;
                    vertical-align: top;
                    margin-left: 33px;
                    overflow: hidden;
                    cursor: pointer;
                    .selectInput{
                        width: 80px;
                        opacity: 0;
                        position: absolute;
                        left: 0;
                        top: 0;
                        cursor: pointer;
                    }
                    span{
                        color: #999999;
                    }
                }
                .btn_type2{
                    display: inline-block;
                    vertical-align: top;
                    margin-left: 130px;
                    span{
                        font-size: 14px;
                        color: #E0466E;
                        cursor: pointer;
                    }
                }
            }
            .btn_type1{
                padding: 5px 20px;
                border: 1px solid #E5E5E5;
                border-radius: 3px;
                color: #333333;
                font-size: 14px;
                background-color: #fff;
                margin-left: 15px;
                cursor: pointer;
            }
            .btn_type1_avtive{
                padding: 5px 20px;
                border: 1px solid #E0466E;
                border-radius: 3px;
                color: #ffffff;
                font-size: 14px;
                background-color: #E0466E;
                margin-left: 15px;
                cursor: pointer;
            }
            .controlMore{
                overflow: hidden;
                margin-top: 22px;
                .controlMore_lis{
                    height: 32px;
                    line-height: 32px;
                }
                .controlMore_lis2{
                    margin-top: 15px;
                    .inputSearch{
                        margin-left: 27px;
                        position: relative;
                        width: 300px;
                        display: inline-block;
                        vertical-align: top;
                        .iconsearch{
                            position: absolute;
                            right: 8px;
                            top: 7px;
                            cursor: pointer;
                            svg{
                                font-size: 26px;
                                color: #E0466E;
                            }
                        }
                    }
                }
            }
        }
      .box_list{
        background-color: #fff;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 30px;
      }
    }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {

    }
</style>

